export default "__VITE_ASSET__CXKSybOY__"